import { Component } from 'react';
import { getTranslationKey } from '../../../modules/utils/helpers';

const TRACKING_STATUS = {
  in: 'opt-in',
  out: 'opt-out'
};

interface User {
  _id: string;
}

interface BookingSite {
  _id: string;
  ga_id?: string;
  fb_pixel_id?: string;
  gtm_id?: string;
  _user: User;
}

interface TrackingProps {
  bookingSite: BookingSite;
}

interface TrackingState {
  visible: boolean;
}

class Tracking extends Component<TrackingProps, TrackingState> {
  private loggedGA: boolean;

  private loggedFB: boolean;

  private loggedGTM: boolean;

  constructor(props: TrackingProps) {
    super(props);

    this.state = {
      visible: true
    };

    this.opt = this.opt.bind(this);
    this.loggedGA = false;
    this.loggedFB = false;
    this.loggedGTM = false;
  }

  componentDidMount() {
    this.tracking();

    const trackingStatus = this.getTrackingStatus();
    const visible = !trackingStatus || trackingStatus === TRACKING_STATUS.out;

    this.setState({ visible });
  }

  componentDidUpdate() {
    this.tracking();
  }

  getTrackingStatus(): string | null {
    return window.localStorage.getItem(`${this.props.bookingSite._id}-tracking`);
  }

  setTrackingStatus(status: string) {
    window.localStorage.setItem(`${this.props.bookingSite._id}-tracking`, status);
  }

  tracking() {
    if (window.navigator.onLine) {
      const trackingStatus = this.getTrackingStatus();
      const { ga_id, fb_pixel_id, gtm_id } = this.props.bookingSite;

      if (trackingStatus === TRACKING_STATUS.in) {
        if (ga_id && !this.loggedGA) {
          this.loggedGA = true;
        }
        if (fb_pixel_id && !this.loggedFB) {
          this.loggedFB = true;
        }
        if (gtm_id && !this.loggedGTM) {
          this.loggedGTM = true;
        }
      }
    }
  }

  opt(status: string) {
    this.setTrackingStatus(status);
    this.setState({ visible: false });
  }

  render() {
    const { ga_id, fb_pixel_id, _user, gtm_id } = this.props.bookingSite;
    const { visible } = this.state;
    if (visible && (ga_id || fb_pixel_id || gtm_id)) {
      return (
        <div className="row">
          <div className="tracking-hint col-sm-12 col-xs-12 col-md-4 col-lg-4 col-xl-3">
            <div className="row">
              <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                {getTranslationKey('trackingHint')}{' '}
                <a
                  href={`/api/privacy/view?user_id=${_user._id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {getTranslationKey('more')}
                </a>
              </div>
              <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12 text-center">
                <button onClick={() => this.opt(TRACKING_STATUS.out)} className="btn-opt-out p-15">
                  {getTranslationKey('optOut')}
                </button>
              </div>
              <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12">
                <button
                  onClick={() => this.opt(TRACKING_STATUS.in)}
                  className="site-button w-100-p"
                >
                  {getTranslationKey('optIn')}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

export default Tracking;
